export default __webpack_public_path__ + "static/media/home-page-second-section.c13c5b06.jpg";